export default __webpack_public_path__ + "static/media/tabler-icon-checkbox.cc5390b4.svg";